export const STATUS = {
  Pending: "PENDING",
  Approved: "APPROVED",
  Rejected: "REJECTED",
  Terminate: "TERMINATE",
};

export const OS_OPTIONS = [
  { label: "Amazon Linux", value: "amazon", image: "/assets/icons/amazonLinux.png" },
  { label: "Ubuntu", value: "ubuntu", image: "/assets/icons/ubuntu.png" },
  { label: "Redhat", value: "redhat", image: "/assets/icons/redhat.png" },
  // { label: "Suse", value: "suse" },
  { label: "Debian", value: "debian", image: "/assets/icons/debian.png" },
];